module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_function_of_plasma_5-9c7dd0699d91b25ea2875152398bcde1.jpg";